export default __webpack_public_path__ + "static/media/valuation_new.25e2f14c.png";